"use client"

import { subscribeNewsletter } from "@lib/data/newsletter"
import { Button, Input, Text } from "@modules/common/components/ui"
import { FormEvent, useState } from "react"

type Status = "idle" | "loading" | "success" | "error"

export default function NewsletterForm() {
  const [email, setEmail] = useState("")
  const [status, setStatus] = useState<Status>("idle")

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    if (!email || status === "loading") {
      return
    }

    setStatus("loading")

    const { subscribed } = await subscribeNewsletter(email)

    setStatus(subscribed ? "success" : "error")
  }

  if (status === "success") {
    return (
      <Text
        role="status"
        className="txt-small text-ui-fg-base"
        data-testid="newsletter-success"
      >
        You&rsquo;re in — watch your inbox
      </Text>
    )
  }

  return (
    <form
      onSubmit={handleSubmit}
      className="flex flex-col gap-y-2"
      data-testid="newsletter-form"
    >
      <span className="txt-small-plus text-ui-fg-base">
        Get deals &amp; new product alerts
      </span>
      <div className="flex gap-x-2">
        <Input
          type="email"
          name="email"
          required
          placeholder="you@example.com"
          aria-label="Email address for deals and new product alerts"
          autoComplete="email"
          value={email}
          onChange={(e) => {
            setEmail(e.target.value)
            if (status === "error") {
              setStatus("idle")
            }
          }}
          className="h-9 text-sm"
          data-testid="newsletter-email-input"
        />
        <Button
          type="submit"
          variant="primary"
          size="small"
          className="h-9 shrink-0"
          isLoading={status === "loading"}
          data-testid="newsletter-subscribe-button"
        >
          Subscribe
        </Button>
      </div>
      {status === "error" && (
        <Text
          role="alert"
          className="txt-compact-xsmall text-red-600"
          data-testid="newsletter-error"
        >
          Something went wrong — please try again
        </Text>
      )}
    </form>
  )
}
